module.exports = __webpack_public_path__ + "static/nxrt-automotive5-b44497893cc098a92c7cc9f834fe0637.jpg";